// extracted by mini-css-extract-plugin
module.exports = {"toast":"App_toast__18xND"};